import * as Yup from "yup";
import { getOptions } from "@features/dropdownOptions/fetchOptions";

import { InputT2Group, ModuleSchema, OptionalSubmodule, StartWithWithoutGeneric, T2Schema } from "@typedefs/modulesInterfaces";
import { FieldType } from "@typedefs/modulesInterfaces";
import { validatePositiveNumber } from "../moduleUtils";
import type { ModuleFull, InputEntryResponse } from "./inputsTypes";
import { DropdownInputGroup } from "@typedefs/modulesInterfaces";
import { ENTRY_ENDPOINT, TAG_ENTRY_DEFAULTS } from "@app/features/modules/inputsApiSlice";

const inputTypes = () => getOptions("inputTypes")

export const validationSchema = Yup.object({
	entries: Yup.array().of(
		Yup.object().shape({
			input_type: validatePositiveNumber.required('validations.input_type_required'),
			value_start: validatePositiveNumber.required('validations.amount_required'),
			value_w: validatePositiveNumber.required('validations.amount_required'),
			value_wo: validatePositiveNumber.required('validations.amount_required'),
		}),
	),
});

const getOptionalSubmodules: () => OptionalSubmodule<InputEntryResponse>[] = () => {
	const inputTypeSelect: DropdownInputGroup = {
		type: FieldType.SELECT,
		label: "module.input_type",
		inputName: (index: number) => `entries.${index}.input_type`,
		dropdownOptions: inputTypes ?? [],
	}

	const valuesSww: StartWithWithoutGeneric = {
		type: FieldType.SWW,
		label: "module.value",
		inputName: (index: number) => `entries.${index}.value`,
		unit: (index: number) => `entries.${index}.input_type_unit`,
	}

	return [{
		name: "project.inputs",
		inputName: "entries",
		inputGroups: [inputTypeSelect, valuesSww],
		repeatable: true,
		linkedTierTwoInputs: ["tiertwo.inputs"],
		route: "inputs",
		cacheTag: "InputEntriesDefaults",
	}]
}

const getInputT2Submodules: () => OptionalSubmodule<InputT2Group>[] = () => {
	const inputT2: InputT2Group = {
		type: FieldType.INPUT_T2,
		inputName: (index: number) => `entries.${index}`,
		label: "",
	}

	return [{
		name: "project.inputs",
		inputName: "entries",
		inputGroups: [inputT2],
		repeatable: true,
		linkedTierTwoInputs: ["tiertwo.inputs"],
		route: ENTRY_ENDPOINT,
		cacheTag: TAG_ENTRY_DEFAULTS,
	}]
}

export const getSchemas = () => {
	const moduleSchema: ModuleSchema = {
		initInputGroups: [],
		mandatorySubmodules: [],
		optionalSubmodules: getOptionalSubmodules(),
	};

	const t2Schema: T2Schema = {
		submodules: [],
		optionalSubmodules: getInputT2Submodules(),
	};

	return { moduleSchema, t2Schema };
}

export const initialValues: ModuleFull = {
	entries: [],
	parent: {
		id: null,
		note: null,
		activity: null,
		start_year: null,
		soc_t2_start: null,
		soc_t2_w: null,
		soc_t2_wo: null,
		status: null,
	}
}